import React, { createContext, useContext, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";

const AppContext = createContext(null);

export function AppProvider({ children }) {
  const [companyId, setCompanyId] = useState("all"); // "all" or company id
  const [directiveOpen, setDirectiveOpen] = useState(false);

  const { data: companies = [] } = useQuery({
    queryKey: ["companies"],
    queryFn: async () => (await api.get("/companies")).data,
  });

  const companyParam = companyId === "all" ? {} : { company_id: companyId };
  const activeCompany = companies.find((c) => c.id === companyId) || null;

  return (
    <AppContext.Provider
      value={{ companyId, setCompanyId, companies, companyParam, activeCompany, directiveOpen, setDirectiveOpen }}
    >
      {children}
    </AppContext.Provider>
  );
}

export const useApp = () => useContext(AppContext);
